/**
 * Program: refine title
 * Author: SKP
 * Description: refine title filter
 */
import { StringUtil } 	from '@/utils';
export default title => {
	if(StringUtil.isNull(title)) {
		return "";

	} else {
		title = title.replace("@R@", ""); // Recommend
		title = title.replace("@H@", ""); // Hot
		title = title.replace("@N@", ""); // New
		title = title.replace("@U@", ""); // Update
		title = title.replace("@I@", ""); // Important
		title = title.replace("@M@", ""); // Must read

		return title;
	}
}



// WEBPACK FOOTER //
// ./src/filters/refTitle.js